import { snakeToTitle } from "./utils";
import { getPath } from "./utils";
import { AtomStructure, Atom } from "./AtomicStructure";

class BindingEnergyDataset {
  constructor(x, y, labels) {
    this.datasetName = "Adsorption Energy";
    this.color = "rgb(253, 97, 97)";
    this.x = x;
    this.y = y;
    this.labels = labels;
  }
  toPlotDataPoints() {
    if (Array.isArray(this.x)) {
      var dataPoints = this.x.map((point, i) => {
        return { x: point, y: this.y[i] };
      });
    } else {
      var dataPoints = [];
    }
    return dataPoints;
  }
}

class ChargeDataset {
  constructor(x, y, labels) {
    this.datasetName = "Charge States";
    this.color = "rgb(70,130,180)";
    this.x = x;
    this.y = y;
    this.labels = labels;
  }
  toPlotDataPoints() {
    if (Array.isArray(this.x)) {
      var dataPoints = this.x.map((point, i) => {
        return { x: point, y: this.y[i] };
      });
    } else {
      var dataPoints = [];
    }
    return dataPoints;
  }
}

export { BindingEnergyDataset, ChargeDataset };
